import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/*
 * Dependentele intre aplicatii - `v4/api/src/Controller/BusinessAppDependenciesController.php`.
 *
 *   GET  /business-apps/{id}/dependencies             de ce depinde, cine o foloseste, impactul, sugestiile
 *   POST /business-apps/{id}/dependencies             other_app_id, direction (depends_on | used_by), description
 *   POST /business-apps/dependencies/{did}/describe   description
 *   POST /business-apps/dependencies/{did}/remove
 *
 * O legatura e muchia `depends_on` intre CI-urile aplicatiilor: analiza de
 * impact a CMDB-ului o urmeaza singura.
 */

export type AppBrief = { appId: number; name: string; criticality: number; criticalityLabel: string }

export type DependencyLine = AppBrief & { id: number; description: string; inCmdb: boolean; origin: string }

export type DependencyDirection = 'depends_on' | 'used_by'

export type DependencySuggestion = AppBrief & { direction: DependencyDirection; evidence: string }

export type DependencyOption = AppBrief & { canDependOn: boolean; canBeUsedBy: boolean }

export type AffectedApp = AppBrief & { direct: boolean; via: string[] }

export type AppDependenciesPage = {
  ready: boolean
  message?: string
  appId?: number
  name?: string
  canEdit?: boolean
  dependsOn?: DependencyLine[]
  usedBy?: DependencyLine[]
  impact?: { sentence: string; apps: AffectedApp[] }
  suggestions?: DependencySuggestion[]
  options?: DependencyOption[]
  cmdb?: { inCmdb: boolean; propagates: boolean }
}

export type DependencyWritten = { status: 'OK' | 'ERROR'; message: string; id?: number; linked?: boolean }

export function appDependenciesQuery(appId: number) {
  return queryOptions({
    queryKey: ['business-apps', 'dependencies', appId],
    queryFn: () => apiGet<AppDependenciesPage>(`/business-apps/${appId}/dependencies`),
    enabled: appId > 0,
  })
}

export function addAppDependency(
  appId: number,
  fields: { other_app_id: number; direction: DependencyDirection; description: string; origin?: 'manual' | 'suggested' },
) {
  return apiPost<DependencyWritten>(`/business-apps/${appId}/dependencies`, { ...fields, origin: fields.origin ?? 'manual' })
}

export function describeAppDependency(id: number, description: string) {
  return apiPost<DependencyWritten>(`/business-apps/dependencies/${id}/describe`, { description })
}

export function removeAppDependency(id: number) {
  return apiPost<DependencyWritten>(`/business-apps/dependencies/${id}/remove`, {})
}
